import axios from "axios";
import { API_URL } from "@/config";
import { convertToPresenceWithInstitution } from "./dtos";

const store = {
  namespaced: true,

  actions: {
    async getStatistics(_, criteria) {
      const res = await axios.get(`${API_URL}/dashboard/statistics`, { params: criteria });

      if (!res.data) {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getTotalOrdersQuantitiesGroupedByInstitutionMealTypeAndDiet() {
      const res = await axios.get(
        `${API_URL}/dashboard/totalOrdersQuantitiesGroupedByInstitutionMealTypeAndDiet`,
      );

      if (!res.data) {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getPresencesList(_, { filters, mode, page, perPage }) {
      let q = {
        ...filters,
        mode,
        page,
        perPage,
      };

      const res = await axios.get(`${API_URL}/dashboard/presencesList`, { params: q });

      if (!res.data || typeof res.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      const items = res.data.items.map(convertToPresenceWithInstitution);
      return { ...res.data, items };
    },

    async getChartData(_, criteria) {
      const res = await axios.get(`${API_URL}/dashboard/chartData`, { params: criteria });

      if (!res.data || typeof res.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },
  },
};

export default store;
